import v1search from './v1search'
import v1searchQuery from './v1searchQuery'

export default {
  v1search,
  v1searchQuery,
}
